import { useQuery } from "@tanstack/react-query";
import { Disclosure } from "../../../components/Disclosure";
import { ComunicacionAjax } from "../../../ts/api/comunicacion";
import { TypedTable } from "../../../components/TypedTable";
import { useNavigate } from "react-router";
import { useMemo, useState } from "react";
import { Breadcrumb } from "../../../components/Breadcrumb";
import { createColumnHelper } from "@tanstack/react-table";
import { Loading, QueryError } from "../../../components/Loading/Loading";

export function EmpaquetadoPedidosPage() {
	const [filtroCiclo, setFiltroCiclo] = useState("");
	const [filtroMedio, setFiltroMedio] = useState("");
	const [filtroPedido, setFiltroPedido] = useState("");

	return (
		<div id="content" className="content" >
			<title>Almacen | Gestor de listado de Ordenes </title>
			<div>
				<Breadcrumb
					sectionTitle="Empaquetado"
					links={[
						{ label: "Listado de Pedidos", active: true }
					]}
				/>

				<Disclosure style={{ marginBottom: 20 }}>
					{/* First element is the summary, second is the content */}
					<h4 className="panel-title panel-heading senalar">
						Filtro
					</h4>
					<FiltroPedidos
						filtroCiclo={filtroCiclo} setFiltroCiclo={setFiltroCiclo}
						filtroMedio={filtroMedio} setFiltroMedio={setFiltroMedio}
						filtroPedido={filtroPedido} setFiltroPedido={setFiltroPedido}
					/>
				</Disclosure>

				<div className="table-responsive">
					<TablaPedidos
						filtroCiclo={filtroCiclo}
						filtroMedio={filtroMedio}
						filtroPedido={filtroPedido}
					/>
				</div>
			</div>
		</div>
	);
}

interface FiltroPedidosProps {
	readonly filtroCiclo: string;
	readonly setFiltroCiclo: (value: string) => void;
	readonly filtroMedio: string;
	readonly setFiltroMedio: (value: string) => void;
	readonly filtroPedido: string;
	readonly setFiltroPedido: (value: string) => void;
}
function FiltroPedidos(props: FiltroPedidosProps) {
	return (
		<div style={{ padding: 30 }} role="tabpanel">
			<div >
				<label >Ciclos: </label>
				<select className="form-control " value={props.filtroCiclo} onChange={e => props.setFiltroCiclo(e.target.value)}>
					<option value="" selected>Elige</option>
				</select>
			</div>
			<div >
				<label >Transportista: </label>
				<select className="form-control " value={props.filtroMedio} onChange={e => props.setFiltroMedio(e.target.value)}>
					<option value="" selected>Elige</option>
				</select>
			</div>
			<div >
				<label >Pedido:</label>
				<input className="form-control " type="text" placeholder="Nº de pedido" value={props.filtroPedido} onChange={e => props.setFiltroPedido(e.target.value)} />
			</div>
		</div>
	);
}

interface TablaPedidosProps {
	readonly filtroCiclo: string;
	readonly filtroMedio: string;
	readonly filtroPedido: string;
}
function TablaPedidos(props: TablaPedidosProps) {
	const navigate = useNavigate();



	const { data, isPending, error } = UsePedidosVenta();
	const columns = useMemo(() => {
		const columnHelper = createColumnHelper<Pedido>();

		function getCeldaPedido(linea: Pedido) {
			const dateFormatter = new Intl.DateTimeFormat("es-ES", {
				year: "numeric",
				month: "2-digit",
				day: "2-digit",
			});
			return (
				<div>
					{linea.idPedido}
					<br />
					{dateFormatter.format(new Date(linea.timestampPedido * 1000))}
				</div>
			);
		}
		function getBtnAccion(linea: Pedido) {
			const onClick = () => {
				const params = new URLSearchParams({
					"idPedido": String(linea.idPedido),
				});
				void navigate("/empaquetado?" + params.toString());
			};

			return (
				<button className="icon-round button-primary-color square35 empaquetar" onClick={onClick} type="button">
					<i className="fa fa-boxes-packing"></i>
				</button>
			);
		}

		return [
			columnHelper.display({
				id: "pedido",
				header: "Pedido",
				cell: info => getCeldaPedido(info.row.original),
			}),
			columnHelper.accessor("nombreCliente", { header: "Cliente" }),
			columnHelper.display({
				id: "accion",
				header: "Acción",
				cell: info => getBtnAccion(info.row.original),
			}),
		];
	}, [navigate]);

	const pedidosFiltrados = useMemo(() => {
		return getPedidosFiltrados(props.filtroCiclo, props.filtroMedio, props.filtroPedido, data ?? {});
	}, [props.filtroCiclo, props.filtroMedio, props.filtroPedido, data]);



	if (error) return <QueryError error={error} fallback="Error al cargar los pedidos" />;
	if (isPending) return <Loading />;




	return (
		<TypedTable
			className="dataTable display"
			data={pedidosFiltrados}
			columns={columns}
		/>
	);
}

function getPedidosFiltrados(filtroCiclo: string | null, filtroMedio: string | null, filtroPedido: string | null, data: Record<number, Ciclo>) {
	let ciclosFiltrados: Ciclo[];
	if (filtroCiclo != null && filtroCiclo != "") {
		ciclosFiltrados = [data[parseInt(filtroCiclo)]];
	} else {
		ciclosFiltrados = Object.values(data);
	}
	const pedidosFiltrados = [];
	for (const ciclo of ciclosFiltrados) {
		const pedidosCicloFiltrados = ciclo.pedidos.filter(pedido => {
			if (filtroMedio != null && filtroMedio != "")
				if (pedido.idMedio != parseInt(filtroMedio)) return false;
			if (filtroPedido != null && filtroPedido != "")
				if (!String(pedido.idPedido).includes(filtroPedido)) return false;
			return true;
		});
		pedidosFiltrados.push(...pedidosCicloFiltrados);
	}

	return pedidosFiltrados;
}

function UsePedidosVenta() {
	return useQuery<Record<number, Ciclo>>({
		queryKey: ["getPedidosLanzados"],
		queryFn: () => {
			const url = "/api/v1/getPedidosLanzados";
			return ComunicacionAjax.sendAjaxRequest<Record<number, Ciclo>>("GET", url);
		},
	});
}

interface Ciclo {
	idCiclo: number;
	prioridadCiclo: number;
	pedidos: Pedido[];
}
interface Pedido {
	idMedio: number;
	nombreMedio: number;
	idPedido: number;
	nombreCliente: string;
	timestampPedido: number;
}